export default {
  state: {
    opened: false,
    payload: null,
    type: null,
  },
  getters: {
    getOpened: state => state.opened,
    getPayload: state => state.payload,
    getType: state => state.type,
  },
  mutations: {
    cleanUp(state) {
      state.type = null;
      state.payload = null;
    },
    close(state) {
      state.opened = false;
    },
    open(state, { payload, type }) {
      state.payload = payload;
      state.type = type;
      state.opened = true;
    },
  },
  actions: {
    cleanUp({ commit }) {
      commit('cleanUp');
    },
    close({ commit }) {
      commit('close');
    },
    openCompositeAdd({ commit }, payload) {
      commit('open', { payload, type: 'composite-add' });
    },
    openCompositeDelete({ commit }, payload) {
      commit('open', { payload, type: 'composite-delete' });
    },
    openCompositeUpdate({ commit }, payload) {
      commit('open', { payload, type: 'composite-update' });
    },
    openLaborEdit({ commit }, payload) {
      commit('open', { payload, type: 'labor-edit' });
    },
    openMaterialAdd({ commit }, payload) {
      commit('open', { payload, type: 'material-add' });
    },
    openMaterialCatalogEdit({ commit }, payload) {
      commit('open', { payload, type: 'material-cat-edit' });
    },
    openMaterialDelete({ commit }, payload) {
      commit('open', { payload, type: 'material-delete' });
    },
    openMaterialQuantity({ commit }, payload) {
      commit('open', { payload, type: 'material-quantity' });
    },
    openMaterialSubcontracting({ commit }, payload) {
      commit('open', { payload, type: 'material-subcontracting' });
    },
    openPhaseAdd({ commit }, payload) {
      commit('open', { payload, type: 'phase-add' });
    },
    openPhaseDelete({ commit }, payload) {
      commit('open', { payload, type: 'phase-delete' });
    },
  },
};
